module.exports = __webpack_public_path__ + "img/icon_roomcard.8aa7966c.png";